import { action } from 'satcheljs';

export const createEmail = action('createEmail');
